import React from 'react';
import PropTypes from 'prop-types';

import { useFormState } from 'react-use-form-state';

import { Input, Form, FormGroup, FormFeedback } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
import styled from 'styled-components';

import ConfirmDeleteWarning from 'components/ConfirmDeleteWarning';

const ContentWrapper = styled.label`
  color: #333;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const DeleteForm = ({ event, onSubmit, onCancel }) => {
  const [formState, { text }] = useFormState({
    title: '',
  });

  const { validity } = formState;

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(event._id);
      }}
    >
      <ContentWrapper>
        You are about to delete the <strong>{event.title}</strong>. This action
        cannot be undone! All content within this event will be permanently
        deleted from Shoflo. Any crew member or team admin who had access to
        this event will no longer be able to access it.
      </ContentWrapper>

      <FormGroup>
        <ConfirmDeleteWarning
          id="eventTitleLabel"
          htmlFor="eventTitle"
          deleteObjectTitle={event.title}
        />

        <Input
          data-testid="eventTitle"
          id="eventTitle"
          aria-labelledby="eventTitleLabel"
          placeholder="e.g. Global Summit 2019"
          {...text({
            name: 'title',
            validate: (v) => {
              return v.trim() === event.title.trim();
            },
            touchOnChange: true,
          })}
          invalid={formState.touched.title && !formState.validity.title}
          required
        />
        {validity.title === false && (
          <FormFeedback> Event names must match.</FormFeedback>
        )}
      </FormGroup>
      <div className="float-end modal-footer">
        <Button
          data-testid="deleteButton"
          color="danger"
          disabled={!formState.validity.title}
        >
          Delete
        </Button>{' '}
        <Button
          color="secondary"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </Button>
      </div>
    </Form>
  );
};

DeleteForm.propTypes = {
  event: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default DeleteForm;
